import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperContextService } from '../../../../../../services/stepper-context.service';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { AboutYouSteps } from '../../../../../../enums/about-you-steps.enum';
import { StepperTasksService } from '../../../../../../services/stepper-tasks.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';

export enum CitizenshipOptions {
  US = 'US Citizen',
  PermanentResident = 'Permanent Resident',
  NonPermanentResident = 'Non-Perm Resident',
  NonResidentAlien = 'Non-Resident Alien'
}

@Component({
  selector: 'lgv-borrower-citizenship',
  standalone: true,
  imports: [CommonModule,
    MatDividerModule, MatButtonModule
  ],
  templateUrl: './borrower-citizenship.component.html',
  styleUrls: ['./borrower-citizenship.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BorrowerCitizenshipComponent {

  CitizenshipOptions = CitizenshipOptions
  isDialog = this.contextService.isDialog
  optionSelected = this.answerService.getAnswer(AboutYouSteps.BorrowerCitizenship) ?? ''

  @Output() stepChange = new EventEmitter<any>();
  @Output() closeDialog = new EventEmitter<any>();

  private usTasks: string[] = [
    "Driver's License",
    "Passport"
  ];

  private permanentResidentTasks: string[] = [
    "Social Security Card",
    "Permanent Resident Card (Green Card)"
  ];

  private nonPermanentResidentTasks: string[] = [
    "Social Security Card",
    "Valid Visa or EAD Card"
  ];

  private nonResidentAlienTasks: string[] = [
    "ITIN Card or IRS ITIN"
  ];

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    public taskService: StepperTasksService
  ) { }

  ngOnInit(): void {
    this.syncTasksWithAnswer(this.optionSelected);
  }

  onAnswerSelected(ans: string) {
    this.optionSelected = ans
    this.clearAllCitizenshipTasks()
    this.syncTasksWithAnswer(ans)
  }

  onNext() {
    this.answerService.setAnswer(AboutYouSteps.BorrowerCitizenship, this.optionSelected)
    this.clearAllCitizenshipTasks();
    this.syncTasksWithAnswer(this.optionSelected);
    this.goToStep(AboutYouSteps.BorrowerMilitary)
  }

  onBack() {
    this.answerService.setAnswer(AboutYouSteps.BorrowerCitizenship, this.optionSelected)
    this.clearAllCitizenshipTasks();
    this.stepChange.emit(AboutYouSteps.BorrowerCurrentAddress);
  }

  goToStep(step) {
    this.stepChange.emit(step);
  }

  isBtnSelected(option: string) {
    if (option === this.optionSelected) {
      return true
    }
  }

  isNextDisabled(): boolean {
    if (this.optionSelected === '') {
      return true
    }
    return false
  }

  private clearAllCitizenshipTasks(): void {
    [...this.usTasks, ...this.permanentResidentTasks, ...this.nonPermanentResidentTasks, ...this.nonResidentAlienTasks]
      .forEach(task => this.taskService.removeTask(task));
  }

  private syncTasksWithAnswer(answer: string): void {
    switch (answer) {
      case CitizenshipOptions.US:
        this.usTasks.forEach(task => this.taskService.addTask(task));
        break;
      case CitizenshipOptions.PermanentResident:
        this.permanentResidentTasks.forEach(task => this.taskService.addTask(task));
        break;
      case CitizenshipOptions.NonPermanentResident:
        this.nonPermanentResidentTasks.forEach(task => this.taskService.addTask(task));
        break;
      case CitizenshipOptions.NonResidentAlien:
        this.nonResidentAlienTasks.forEach(task => this.taskService.addTask(task));
        break;
    }
  }
}
